// extracted by mini-css-extract-plugin
export default {"searchBar":"styles_searchBar__Ds680","input":"styles_input__9xKJn"};